export const listAttendees = (users, type, container) => {
  let abody = users
    .map((list) => {
      let listName, remindOne, remindTwo, email, key;
      if (type == "faculty") {
        listName = list.name;
        email = list.email;
        key = list.user_id;
      } else {
        //let attendee = list[0];
        list.map((attendee) => {
          console.log("users: ", attendee);
          if (typeof attendee.degree !== null) {
            listName = `${attendee.firstName} ${attendee.lastName}, ${attendee.degree}`;
          } else {
            listName = `${attendee.firstName} ${attendee.lastName}`;
          }
          email = attendee.email;
          key = attendee.id;
        });
      }

      if (list.first_reminder == 1) {
        remindOne = `<span class='ball'></span>`;
      } else {
        remindOne = `<span class='transparent-ball'></span>`;
      }
      if (list.second_reminder == 1) {
        remindTwo = `<span class='ball'></span>`;
      } else {
        remindTwo = `<span class='transparent-ball'></span>`;
      }
      console.log("ListName:", listName);
      return `<tr key=${key}>
        <td style='width: 40% !important;'>${listName}</td>
        <td style='width: 30% !important;'> ${email} </td>
        <td style='width: 10% !important;><button class='btn btn-primary' name='launchModal' data-send="0" data-mode='preview' data-email='confirmation'>Confirmation</button></td>
        <td style='width: 10% !important;'><button class='btn btn-primary' name='launchModal' data-send="0" data-mode='preview' data-email='reminder'>Reminder</button></td>
        <td style='width: 5% !important;'>${remindOne}</td>
        <td style='width: 5% !important;'>${remindTwo}</td>
      </tr>`;
    })
    .join("");
  let showContainer = document.getElementById(`${container}`);
  showContainer.innerHTML = "";
  showContainer.innerHTML += abody;
};
